import { Button, Text, theme } from 'components';
import React from 'react';
import { LayoutContext } from 'contexts';
import styled from 'styled-components';
import { BannerContainer } from './constants';
import BannerAlert from './BannerAlert';
import SelectUpgradePlanModal from './SelectUpgradePlanModal';

const AgentPlanUpgradeBanner = () => {
  const { isMobileView } = React.useContext(LayoutContext);
  const [modalVisible, setModalVisible] = React.useState(false);

  React.useEffect(() => {
    const popStateHandler = () => {
      setModalVisible(false);
    };

    window.addEventListener('popstate', popStateHandler);
    return () => {
      window.removeEventListener('popstate', popStateHandler);
    };
  }, []);

  return (
    <>
      <BannerAlert
        message={
          <BannerContainer>
            <Text textAlign="center" block={false} nowrap={!isMobileView}>
              <WaveEmoji>👋</WaveEmoji>
              You&apos;re on the agent plan
              <ViewBrokeragePlanButton
                type="link"
                data-cy="view-brokerage-button"
                onClick={() => setModalVisible(true)}
              >
                View Brokerage Plan
              </ViewBrokeragePlanButton>
            </Text>
          </BannerContainer>
        }
        backgroundColor={theme.blue1}
        data-cy="upgrade-agent-plan-banner"
      />
      <SelectUpgradePlanModal
        closeModal={() => setModalVisible(false)}
        visible={modalVisible}
      />
    </>
  );
};

export default AgentPlanUpgradeBanner;

const ViewBrokeragePlanButton = styled(Button)`
  span {
    font-weight: 500;
  }
`;

const WaveEmoji = styled.div`
  display: inline-block;
  text-align: left;
  margin: 0 5px;
  height: 17px;
  min-width: 17px;
`;
